import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  subLabel?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  subLabel,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const pad = size === 'lg' ? 'px-6 py-5 text-base sm:text-lg' : 'px-5 py-4 text-sm sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-27" data-mp="qjsbxkunxhad">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl bg-teal-400 text-center font-extrabold uppercase leading-tight tracking-wide text-ink-900 shadow-[0_10px_30px_-10px_rgba(37,201,204,0.7)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-teal-300 active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-200 ${pad}`} data-id="element-28" data-mp="qiqw732pc6mb">
        <span className="max-w-[22ch] sm:max-w-none" data-id="element-29" data-mp="15bayk1i12a2p">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="35y7i8daaiuyg" />
      </a>
      {subLabel ? <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-[0.12em] text-teal-200/80 sm:text-xs" data-id="element-31" data-mp="3ewswhw8qbntf">
          {subLabel}
        </p> : null}
    </div>;
}